import {
  SHOW_HEDER_OPTIONS,
  NAV_SELECTION_CHANGE,
  APP_CONFIG,
} from '../constant';

export const updateHeaderOption = (payload) => ({
  type: SHOW_HEDER_OPTIONS,
  payload,
});
export const updateAppConfig = (payload) => ({ type: APP_CONFIG, payload });
export const updateSelectedNav = (payload) => ({
  type: NAV_SELECTION_CHANGE,
  payload,
});
